import MyDateRangeSelector from "src/components/MyDateRangeSelector/MyDateRangeSelector";
import LomaActionsInfo from "../LomaActionsInfo";
import { useLomaData } from "src/context/LomaContext";
import { getYYYYMMDD, parse_yyyymmddhhmm } from "src/components/js/statics1";
import { useState } from "react";
import { personPvm_save, personPvm_updatePersonVehicle } from "src/data/personPvmFunctions";
import { useUserData } from "src/context/userContext";
import { isWeekend } from "date-fns";
import PersonPvmStatusSelector_List from "src/components/PersonPvmStatusSelector_Menu/PersonPvmStatusSelector_List";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import GridVehicleSelectorDialog from "src/components/grid/GridVehicleSelectorDialog";
import { Button, Paper, Typography } from "@mui/material";
import MyDivider from "src/components/layout/MyDivider";
import { DeleteIcon } from "src/components/icons/ActionIcons";

export default function LomaActionsLayout() {
  const { selectedCell, statusList, setIsModalOpen, reload, getDefaultVehicle, vehicleList_all } =
    useLomaData();
  const { token, ownerAsiakasId } = useUserData();
  const [vehicleSelectorIsOpen, setVehicleSelectorIsOpen] = useState(false);

  const pvm = parse_yyyymmddhhmm(selectedCell?.pvm);
  const [vehicle, setVehicle] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [dates, setDates] = useState({
    startDate: pvm,
    endDate: pvm,
  });

  const handleClicked = async (status) => {
    setIsLoading(true);
    const personId = selectedCell.personId;
    let personPvmStatusId = status.personPvmStatusId;
    const personPvmText = "";
    // loop all dates
    const startDate = dates.startDate;
    const endDate = dates.endDate;

    let vehicleId = null;
    if (!status.pois) {
      vehicleId = selectedCell?.vehicleId;
      if (!vehicleId) {
        const _vehicle = getDefaultVehicle(personId);
        vehicleId = _vehicle?.vehicleId;
      }
    }
    const date = new Date(startDate);
    while (date <= endDate) {
      let _personPvmStatusId = personPvmStatusId;
      if (!status.pois && personPvmStatusId === 1 && isWeekend(date)) _personPvmStatusId = 6; // viikonloppu

      const yyyymmdd = getYYYYMMDD(date);

      await personPvm_save(
        null,
        ownerAsiakasId,
        personId,
        yyyymmdd,
        _personPvmStatusId,
        personPvmText,
        vehicleId,
        token
      );
      date.setDate(date.getDate() + 1);
    }

    reload();
    setIsModalOpen(false);
    setIsLoading(false);
  };

  const doSetDates = (dates) => {
    setDates(dates);
  };
  const handleRemoveVehicleClick = async () => {
    setIsLoading(true);
    const personId = selectedCell.personId;
    const startDate = dates.startDate;
    const endDate = dates.endDate;
    const date = new Date(startDate);
    while (date <= endDate) {
      const yyyymmdd = getYYYYMMDD(date);
      await personPvm_updatePersonVehicle(ownerAsiakasId, personId, null, yyyymmdd, token);
      date.setDate(date.getDate() + 1);
    }
    reload();
    setIsModalOpen(false);
    setIsLoading(false);
  };

  const handleSetVehicleClick = async (vehicle) => {
    setIsLoading(true);
    const personId = selectedCell.personId;
    const startDate = dates.startDate;
    const endDate = dates.endDate;
    const date = new Date(startDate);
    while (date <= endDate) {
      const yyyymmdd = getYYYYMMDD(date);
      await personPvm_updatePersonVehicle(
        ownerAsiakasId,
        personId,
        vehicle.vehicleId,
        yyyymmdd,
        token
      );
      date.setDate(date.getDate() + 1);
    }
    reload();
    setIsModalOpen(false);
    setIsLoading(false);
  };

  return (
    <div>
      <LomaActionsInfo />
      <div>
        <MyDateRangeSelector
          disabled={isLoading}
          dates={dates}
          setDates={doSetDates}
          label="Aikaväli"
        />
      </div>
      <ProgressBar show={isLoading} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 6,
          paddingLeft: 12,
          paddingRight: 12,
        }}>
        <Paper elevation={4} style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography variant="body" noWrap>
              Laita poissaolo
            </Typography>
          </div>
          <MyDivider />
          <PersonPvmStatusSelector_List
            disabled={isLoading}
            statusList={statusList}
            onSelect={handleClicked}
          />
        </Paper>
        <Paper elevation={4} style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography variant="body" noWrap>
              Aseta tai poista ajoneuvo
            </Typography>
          </div>
          <MyDivider />
          <div className="flexCol" style={{ padding: 10 }}>
            <Button fullWidth onClick={handleRemoveVehicleClick} variant="outlined">
              <DeleteIcon style={{ fontSize: 20 }} /> Tyhjennä ajoneuvo
            </Button>
            <Button fullWidth onClick={() => setVehicleSelectorIsOpen(true)} variant="outlined">
              Valitse ajoneuvo
            </Button>
          </div>
        </Paper>
      </div>
      <GridVehicleSelectorDialog
        open={vehicleSelectorIsOpen}
        onClose={() => setVehicleSelectorIsOpen(false)}
        onSelect={(vehicle) => {
          setVehicle(vehicle);
          handleSetVehicleClick(vehicle);
        }}
        selectedVehicle={vehicle}
        vehiclesProp={vehicleList_all}
        time={{ starttime: dates.startDate, endtime: dates.endDate }}
      />
    </div>
  );
}
